var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalloutCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89 7.312a.974.974 0 0 1-.653.245.974.974 0 0 1-.652-.245L4.548 5.208 2.512 7.312a.932.932 0 0 1-.3.183 1.007 1.007 0 0 1-.709.003.934.934 0 0 1-.3-.181.833.833 0 0 1-.201-.272.764.764 0 0 1 .003-.642.835.835 0 0 1 .203-.27l2.119-2.188-2.12-2.19a.835.835 0 0 1-.203-.27A.765.765 0 0 1 1 .844a.833.833 0 0 1 .2-.272.934.934 0 0 1 .301-.181 1.008 1.008 0 0 1 .71.002.932.932 0 0 1 .299.184l2.037 2.105L6.585.577a.932.932 0 0 1 .3-.184 1.007 1.007 0 0 1 .709-.002.934.934 0 0 1 .3.18c.087.079.155.171.201.273a.764.764 0 0 1-.003.641.835.835 0 0 1-.203.27L5.77 3.945l2.12 2.188c.085.077.153.17.2.27a.765.765 0 0 1 0 .639.834.834 0 0 1-.2.27z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalloutCross);
export default __webpack_public_path__ + "static/media/Callout_cross.147d04ac.svg";
export { ForwardRef as ReactComponent };